import { useIsMultiProviderScheduleEnabled } from '@/features/flags';
import { useQueryIntegrationsMixinGetSchedule } from '@/hooks/integrations/integrations-framework/mixins/useQueryIntegrationsMixinGetSchedule';
import type { ScheduleItemWithDisplayFacets } from '@heidi/session';
import { deriveScheduleFacetOptions, type ScheduleFacetOptions } from '@heidi/session';

type Params = {
  scheduleDate: string | undefined;
  enabled: boolean;
};

/** Unfiltered query used only to derive dropdown option metadata. */
export function useScheduleFilterOptions({ scheduleDate, enabled }: Params) {
  const isFlagEnabled = useIsMultiProviderScheduleEnabled();

  return useQueryIntegrationsMixinGetSchedule<ScheduleFacetOptions>({
    start_date: scheduleDate,
    end_date: scheduleDate,
    enabled: enabled && isFlagEnabled,
    select: (schedule) =>
      deriveScheduleFacetOptions(schedule as readonly ScheduleItemWithDisplayFacets[]),
  });
}
